import React from "react";
import AddModal from "../../components/Invoice/sections/modal/AddModal";

export const DeleteProject = ({
  title,
  subTitle,
  cancelFn,
  actionFn,
  cancelText,
  actionText
}: {
  title: string;
  subTitle: string;
  cancelText: string;
  actionText: string;
  cancelFn: () => void;
  actionFn: () => void;
}) => {
  return (
    <AddModal>
      <div className="px-3 py-2 rounded-xl">
        <h1 className="font-semibold text-xl">{title}</h1>

        <p className="text-[#344054] font-medium text-base mt-4">
         {subTitle}
        </p>

        <div className="flex justify-end gap-3 mt-4">
          <button onClick={cancelFn} className="px-4 py-3 rounded bg-white border-[1px] border-[#D0D5DD] text-base font-semibold">
           {cancelText}
          </button>
          <button onClick={actionFn} className="px-4 py-3 rounded bg-[#D92D20] text-white text-base font-semibold">
            {actionText}
          </button>
        </div>
      </div>
    </AddModal>
  );
};
